import { z } from 'zod';
import { GATEWAY_CONFIG_PUSH_STATUSES } from './gateway-config-push-keys.js';
export const GatewaySerialParamSchema = z.object({
    serialNumber: z.string().min(1).max(64),
});
export const GatewayConfigVersionParamSchema = GatewaySerialParamSchema.extend({
    version: z.string().min(1).max(64),
});
export const GatewayConfigPushHistoryItemSchema = z.object({
    configVersion: z.string(),
    status: z.enum(GATEWAY_CONFIG_PUSH_STATUSES),
    pushedAt: z.string().datetime(),
    pushedBy: z.object({ userId: z.string(), email: z.string() }).optional(),
    mqttSentAt: z.string().datetime().optional(),
    mqttAckAt: z.string().datetime().optional(),
    errorMessage: z.string().optional(),
    pushMetadata: z.record(z.unknown()).optional(),
    edgeResponse: z.record(z.unknown()).optional(),
    scopeId: z.string().uuid().optional(),
});
export const GatewayConfigPushHistoryResponseSchema = z.object({
    success: z.literal(true),
    data: z.object({
        gatewaySerialNumber: z.string(),
        gatewayType: z.enum(['efem', 'location']),
        deviceCategory: z.enum(['efem-gateway', 'location-gateway']),
        items: z.array(GatewayConfigPushHistoryItemSchema),
    }),
});
export const GatewayConfigResendMqttResponseSchema = z.object({
    success: z.literal(true),
    data: z.object({
        mqttRequestId: z.string().uuid(),
        status: z.string(),
    }),
});
//# sourceMappingURL=gateway-config-push-schemas.js.map